<template>
  <div
    :class="`${wrapper}__link`"
    :title="phone.label"
    :aria-label="phone.label"
  >
    <img :src="phone.icon" :alt="phone.label" @click="hasShown = !hasShown" />
    <div :class="`${wrapper}__phone`" v-if="hasShown">
      <a :href="`tel:${phone.number}`">{{ phone.number }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuthorPhone",
  props: {
    wrapper: {
      type: String,
      required: true
    },
    phone: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    hasShown: false
  })
};
</script>
